export default __webpack_public_path__ + "static/media/Eye_4_M_C1.e3fdb522.svg";